import type { CalendarId } from 'owa-graph-schema';
import { getApolloClient } from 'owa-apollo';
import {
    UpdateCalendarHexColorDocument,
    UpdateCalendarHexColorMutation,
} from '../graphql/__generated__/updateCalendarHexColorMutation.interface';

export type UpdateCalendarHexColorResult = UpdateCalendarHexColorMutation['updateCalendarHexColor'];

/**
 * sets calendar hex color on server
 * @param id id of the calendar that needs to be deleted
 * @param calendarColor the calendar color to set
 */
export default async function setCalendarHexColorService(
    calendarId: CalendarId,
    calendarColor: string
): Promise<UpdateCalendarHexColorResult> {
    const client = await getApolloClient();

    const mutationResult = await client.mutate({
        variables: {
            calendarId: {
                id: calendarId.id,
                changeKey: calendarId.changeKey,
                mailboxInfo: calendarId.mailboxInfo,
            },
            hexColor: calendarColor,
        },
        mutation: UpdateCalendarHexColorDocument,
    });

    return mutationResult?.data?.updateCalendarHexColor;
}
